export default __webpack_public_path__ + "static/media/edit-light.f10c3fba.svg";